import React, { useCallback, useState } from 'react'
import { useMount } from 'react-use'
import * as apis from '@/apis'
import { useHistory } from 'react-router-dom';
import { Spin, Button } from 'antd'
import styles from './summary.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import * as userActions from '@/models/user/actions'
import * as userSelector from '@/models/user/selectors'
import { showRechargeDialog } from '@/models/tenants/actions'

export default function FinancesSummary(props) {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState(null)
  const user = useSelector(userSelector.getCurrentUser)
  const tenant = user.getIn(['staff', 'tenant'])
  const history = useHistory();
  const openRechargeDialog = useCallback(() => {
    dispatch(showRechargeDialog({
      title: '企业充值'
    }))
  }, [])
  const viewBilled = useCallback(() => {
    history.push(`/enterprises/${tenant._id}/bills?type=billed`)
  })
  const viewUnBilled = useCallback(() => {
    history.push(`/enterprises/${tenant._id}/bills?type=unbilled`)
  })
  useMount(() => {
    apis.getFinancesSummary()
      .then(result => {
        setLoading(false)
        setData(result)
      })
  })

  if (!tenant) {
    return null
  }

  return (
    <Spin spinning={loading}>
      <div className={styles.summary}>
        <div className={styles.item}>
          <div className={styles.itemTitle}>
            可用余额
            <Button
              className={styles.recharge}
              size="small"
              type="primary"
              onClick={openRechargeDialog}>充值</Button>
          </div>
          <div className={styles.itemBody}>
            <div className={styles.value}>{(tenant.balance - tenant.locked_balance).toFixed(2)}</div>
            <div className={styles.suffix}>元</div>
          </div>
        </div>
        <div className={styles.item}>
          <div className={styles.itemTitle}>已冻结余额</div>
          <div className={styles.itemBody}>
            <div className={styles.value}>{tenant.locked_balance.toFixed(2)}</div>
            <div className={styles.suffix}>元</div>
          </div>
        </div>
        <div className={styles.sep}></div>
        <div className={styles.item}>
          <div className={styles.itemTitle}>可用额度/信用额度</div>
          <div className={styles.itemBody}>
            <div className={styles.value}>
              {(tenant.total_credit - tenant.used_credits - tenant.locked_credits).toFixed(2)}
            </div>
            <div className={styles.suffix}> / {tenant.total_credit} 元</div>
          </div>
        </div>
        <div className={styles.item}>
          <div className={styles.itemTitle}>已冻结额度</div>
          <div className={styles.itemBody}>
            <div className={styles.value}>{tenant.locked_credits.toFixed(2)}</div>
            <div className={styles.suffix}>元</div>
          </div>
        </div>
        <div className={styles.item}>
          <div className={styles.itemTitle}>已使用额度</div>
          <div className={styles.itemBody}>
            <div className={styles.value}>{tenant.used_credits.toFixed(2)}</div>
            <div className={styles.suffix}>元</div>
          </div>
        </div>
        <div className={styles.sep}></div>
        <div className={styles.item}>
          <div className={styles.itemTitle} onClick={viewBilled}>已出账单总计</div>
          <div className={styles.itemBody}>
          <div className={styles.value}><a className={styles.clickValue} onClick={viewBilled}>{data ? data.totalBilledAmount?.toFixed(2): '-'}</a></div>
            <div className={styles.suffix}>元</div>
          </div>
        </div>
        <div className={styles.item}>
          <div className={styles.itemTitle}>待核对账单</div>
          <div className={styles.itemBody}>
          <div className={styles.value}>{data ? data.unCheckedBillCount: '-'}</div>
            <div className={styles.suffix}>条</div>
          </div>
        </div>
        <div className={styles.item}>
          <div className={styles.itemTitle}>未出账单总计</div>
          <div className={styles.itemBody}>
            <div className={styles.value}><a className={styles.clickValue} onClick={viewUnBilled}>{data?.totalUnbilledAmount?.toFixed(2) || '-'}</a></div>
            <div className={styles.suffix}>元</div>
          </div>
        </div>
      </div>
    </Spin>
  )
}
